/**
 * The ShopCategoryLp container
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";
import { useDispatch, useSelector } from "react-redux";
import { showTaxonAndProducts } from "../../redux/shop/taxons";
import { listProducts } from "../../redux/shop/products";
import { useRegisterEffect, useSsrEffect } from "@issr/core";
import { useParams } from "react-router-dom";
import {
  Col,
  Container,
  Row,
  Button,
  ListGroup,
  ListGroupItem,
  Collapse,
  Label,
  FormGroup,
  Input,
  Spinner,
} from "reactstrap";
import ShopProductCardBig from "../../components/ShopProductCardBig";
import ShopProductCard from "../../components/ShopProductCardNew";
import ResponsivePicture from "../../components/ResponsivePicture";
import { REACT_APP_SHOP_CDN_SERVER } from "../../utils/env";
import CMSBlock from "../../components/CMSBlock";
import ShopTaxonCard from "../../components/ShopTaxonCard";
import { MdFilterList } from "react-icons/md";
import Status from "../Utils/Status";
import BreadcrumbBar from "../../components/Utilities/BreadcrumbBar/BreadcrumbBar";

const ShopCategory = (props, context) => {
  const dispatch = useDispatch();
  const registerEffect = useRegisterEffect();
  const [showFilters, setShowFilters] = useState(false);
  const [selectedTaxonomies, setSelectedTaxonomies] = useState([]);

  const { slug, subslug, subsubslug } = useParams();
  const [perPage, setPerPage] = useState(38);
  const shopTaxonSlug = `shop/${slug}${subslug ? "/" + subslug : ""}${
    subsubslug ? "/" + subsubslug : ""
  }`;
  const language = useSelector((state) => {
    return state.i18nState.lang;
  });
  const shopTaxonDictionary = useSelector((state) => {
    return state.shopTaxons.taxonsDictionary[language];
  });
  const shopTaxon = useSelector((state) => {
    return state.shopTaxons.taxonQueriesDictionary[
      language + "/" + shopTaxonSlug
    ];
  });
  const productList = useSelector((state) => {
    return state.shopProducts.list;
  });

  const productsLoading = useSelector((state) => {
    return state.shopProducts.listLoading;
  });

  const lastSlug = useSelector((state) => {
    return state.shopTaxons.lastSlug;
  });

  const errorRedirect = useSelector((state) => {
    return state.shopTaxons.errorRedirect;
  });

  const taxonLoading = useSelector((state) => {
    return state.shopTaxons.showLoading;
  });

  const taxonData = shopTaxon?.data;

  const loadCategory = () => {
    if (
      shopTaxonSlug !== shopTaxon?.data?.attributes?.permalink ||
      language !== shopTaxon?.language ||
      (lastSlug && lastSlug !== shopTaxonSlug)
    ) {
      registerEffect(
        dispatch,
        showTaxonAndProducts({
          slug: shopTaxonSlug,
        })
      );
    }
  };

  const loadTaxonProducts = (newTaxonomies = null) => {
    const filters = [{ key: "taxons", value: taxonData?.id }];

    if (newTaxonomies?.length > 0)
      filters.push({
        key: "concat_taxons",
        value: newTaxonomies?.join(","),
      });
    else if (!newTaxonomies && selectedTaxonomies?.length > 0)
      filters.push({
        key: "concat_taxons",
        value: selectedTaxonomies?.join(","),
      });

    dispatch(
      listProducts({
        filters: filters,
        perPage: perPage + 36,
        language,
      })
    );
  };

  useSsrEffect(loadCategory, [shopTaxonSlug, language]);

  const loadMoreProducts = () => {
    setPerPage(perPage + 36);
    loadTaxonProducts();
  };

  const toggleTaxonomyFilter = (taxon, event) => {
    let newTaxonomies = selectedTaxonomies;
    if (event?.target?.checked) {
      newTaxonomies.push(taxon.id);
    } else {
      newTaxonomies = selectedTaxonomies?.filter((taxonid) => {
        return parseInt(taxonid) !== parseInt(taxon.id);
      });
    }
    setSelectedTaxonomies(newTaxonomies);
    loadTaxonProducts(newTaxonomies);
  };

  // FIXME this also populates empty blocks
  const taxonCmsBlocks = useSelector((state) => {
    return taxonData?.attributes?.cms_blocks?.split(",").map((cmsBlockSlug) => {
      return state?.cmsblocks?.dictionary[language + "-" + cmsBlockSlug];
    });
  });

  const SHOP_API_URL = REACT_APP_SHOP_CDN_SERVER || "https://sdn.myfolie.com";
  const taxonImage = shopTaxon?.included?.find((obj) => {
    return (
      obj.id === taxonData?.relationships?.image?.data?.id &&
      obj.type === "taxon_image"
    );
  });

  let parentCategory = false;
  if (
    shopTaxon?.data?.relationships?.parent?.data &&
    parseInt(shopTaxon?.data?.relationships.parent.data.id) !== 116 &&
    parseInt(shopTaxon?.data?.relationships.parent.data.id) !== 1
  ) {
    parentCategory = shopTaxon?.included?.find((obj) => {
      return (
        obj.id === shopTaxon?.data?.relationships.parent.data.id &&
        obj.type === "taxon"
      );
    });
  }

  let taxonomyFilters = [];
  const avilableFilterIds =
    (taxonData?.attributes?.taxonomy_filter_ids &&
      taxonData?.attributes?.taxonomy_filter_ids.split(",").map(Number)) ||
    [];
  if (avilableFilterIds.length > 0) {
    // if (productList?.included) {
    //   // If products loaded, set helper subsets
    //   if (productList?.data) {
    //     loadedProductIds = productList?.data.map((product) => product.id);
    //   }
    //   // exclude taxon id 1 & 9 since it's the "general category"
    //   if (productList.included) {
    //     taxonomyFilters = productList.included.filter((obj) => {
    //       return (
    //         obj.type === "taxon" &&
    //         parseInt(obj.id) !== 9 &&
    //         parseInt(obj.id) !== 1 &&
    //         obj.id !== shopTaxon?.data?.id &&
    //         !obj.relationships.parent.data
    //       );
    //     });
    //     subTaxonomyFilter = productList.included.filter((obj) => {
    //       return (
    //         obj.type === "taxon" &&
    //         parseInt(obj.id) !== 9 &&
    //         parseInt(obj.id) !== 1 &&
    //         obj.relationships?.parent?.data?.id === shopTaxon?.data?.id
    //       );
    //     });
    //   }
    // }

    // Object.keys(shopTaxonDictionary).forEach((taxonId) => {
    //   console.log(
    //     "checking",
    //     taxonId,
    //     avilableFilterIds,
    //     avilableFilterIds.includes(parseInt(taxonId))
    //   );
    //   if (avilableFilterIds.includes(parseInt(taxonId))) {
    //     taxonomyFilters.push(shopTaxonDictionary[taxonId]);
    //   }
    // });

    if (shopTaxonDictionary) {
      Object.keys(shopTaxonDictionary).forEach((taxonId) => {
        let taxon = shopTaxonDictionary[taxonId];

        if (
          avilableFilterIds.includes(
            parseInt(taxon.relationships.taxonomy.data.id)
          ) &&
          taxon?.attributes?.is_root
        ) {
          taxonomyFilters.push(taxon);
        }
      });
    }
    taxonomyFilters?.sort((a, b) => {
      if (parseInt(a.id) < parseInt(b.id)) return -1;
      if (parseInt(a.id) > parseInt(b.id)) return 1;
      return 0;
    });
  }
  let indexCardCounter = 0;

  const dataLayer = !productsLoading
    ? [
        {
          event: "view_item_list",
          value: productList?.data
            ?.filter((obj) =>
              shopTaxon?.data?.relationships?.products?.data
                ?.map((tp) => tp.id)
                .includes(obj.id)
            )
            .reduce((sum, product) => {
              return sum + (parseFloat(product.attributes.price) || 0);
            }, 0),
          items: productList?.data
            ?.filter((obj) =>
              shopTaxon?.data?.relationships?.products?.data
                ?.map((tp) => tp.id)
                .includes(obj.id)
            )
            .map((product, index) => {
              return {
                name: product.attributes.name,
                id: product.attributes.sku || product.attributes.slug, // TODO We need th master sku!
                price: product.attributes.price,
                brand: "myfolie",
                category: product.attributes.product_type,
                google_business_vertical: "retail",
              };
            }),
        },
        {
          ecommerce: {
            impressions: productList?.data
              ?.filter((obj) =>
                shopTaxon?.data?.relationships?.products?.data
                  ?.map((tp) => tp.id)
                  .includes(obj.id)
              )
              .map((product, index) => {
                return {
                  name: product.attributes.name,
                  id: product.attributes.sku || product.attributes.slug, // TODO We need th master sku!
                  price: product.attributes.price,
                  brand: "myfolie",
                  category: product.attributes.product_type,
                  list: "Category Page",
                };
              }),
          },
        },
      ]
    : null;

  return (
    <Page
      title={taxonData?.attributes?.name}
      image={
        taxonImage?.attributes?.styles[2]?.url
          ? SHOP_API_URL + taxonImage?.attributes?.styles[2]?.url
          : false
      }
      description={
        taxonData?.attributes?.description
          ? taxonData?.attributes?.description
          : false
      }
      dataLayer={dataLayer}
      lang={language}
      pageType="category"
    >
      {errorRedirect && <Status code="404" redirect={errorRedirect} />}
      <div className="hero container" style={{ height: "320px" }}>
        <div className="hero__bg" style={{ height: "320px" }}>
          {taxonImage?.attributes?.styles[2]?.url && (
            <ResponsivePicture
              mediumData={{
                url: SHOP_API_URL + taxonImage?.attributes?.styles[2]?.url,
                metadata: {
                  width: "100%",
                  height: "100%",
                },
              }}
              cover
              skipLazyLoading
              altTitle={taxonData?.attributes?.name}
            />
          )}
        </div>
        <div>
          <header className="col-lg-6 col-12 p-3 bg-white pull-left mt-5 ml-md-3 mb-3 mt-md-8 rounded shadow shadow-md-0">
            <h1 style={{ position: "relative" }} className="h2">
              {taxonData?.attributes?.name}
            </h1>
            <p>{taxonData?.attributes?.description}</p>
          </header>
        </div>
      </div>

      <BreadcrumbBar
        items={
          parentCategory
            ? [
                {
                  link: `/${language}/t/${parentCategory?.attributes?.permalink?.replace(
                    "shop/",
                    ""
                  )}/`,
                  title: parentCategory?.attributes?.name,
                },
              ]
            : []
        }
        current={taxonData ? { title: taxonData?.attributes?.name } : false}
      />

      <Container>
        {avilableFilterIds?.length > 0 && (
          <Row>
            <Col xs={6}>
              <Button
                color="secondary"
                onClick={() => setShowFilters(true)}
                className="mb-2"
                outline
              >
                <MdFilterList className="mr-2" />
                {context.t("Show Filters")}
              </Button>
            </Col>
            <Col xs={6} className="text-right text-info">
              {(productsLoading || taxonLoading) && <Spinner size="sm" />}{" "}
              {productList?.meta?.total_count} {context.t("items")}
            </Col>

            {showFilters && (
              <Col
                lg={3}
                md={12}
                className={`shopcategory__filterbar shopcategory__filterbar--modalopen`}
              >
                <ListGroup>
                  {taxonomyFilters?.map((maintaxon) => (
                    <ListGroupItem key={maintaxon.id}>
                      <div className="h4">{maintaxon.attributes.name}</div>
                      <Collapse isOpen={true}>
                        {maintaxon.relationships?.children?.data.map(
                          (subtaxon, idx) => {
                            const dictionaryTaxon =
                              shopTaxonDictionary[subtaxon.id];
                            let childtaxon = productList?.included?.find(
                              (obj) => {
                                return (
                                  obj.type === "taxon" && obj.id === subtaxon.id
                                );
                              }
                            );
                            let isDisabled = taxonLoading || productsLoading;
                            if (dictionaryTaxon && !childtaxon) {
                              childtaxon = dictionaryTaxon;
                            }
                            return (
                              <FormGroup key={"subtaxon-" + idx} check>
                                <Input
                                  type="checkbox"
                                  disabled={isDisabled}
                                  name={`taxon-${childtaxon?.id}`}
                                  id={`taxon-${childtaxon?.id}`}
                                  checked={selectedTaxonomies?.find((obj) => {
                                    return obj === childtaxon?.id;
                                  })}
                                  onChange={(event) =>
                                    toggleTaxonomyFilter(subtaxon, event)
                                  }
                                />
                                <Label check for={`taxon-${childtaxon?.id}`}>
                                  {childtaxon?.attributes?.name}
                                </Label>
                              </FormGroup>
                            );
                          }
                        )}
                      </Collapse>
                    </ListGroupItem>
                  ))}
                </ListGroup>
                {(taxonLoading ||
                  productsLoading ||
                  taxonomyFilters.length === 0) && (
                  <div className="mt-3 mb-3 small text-secondary text-center">
                    <Spinner size="sm" />{" "}
                    {context.t("updating available filters...")}
                  </div>
                )}
                <div className="shopcategory__mobilefilterclose mt-3">
                  <Button
                    color="primary"
                    onClick={() => setShowFilters(false)}
                    block
                  >
                    {context.t("Hide Filters")}
                  </Button>
                </div>
              </Col>
            )}
          </Row>
        )}

        <Row>
          {taxonData?.relationships?.children?.data?.map((childTax) => {
            const includedTaxon = shopTaxon?.included?.find((obj) => {
              return obj.id === childTax?.id && obj.type === "taxon";
            });
            if (includedTaxon?.attributes?.hide_from_category_page) {
              return <></>;
            }
            indexCardCounter++;
            return (
              <Col
                key={`taxon-${indexCardCounter}`}
                xl={indexCardCounter < 3 ? 6 : 3}
                lg={indexCardCounter < 3 ? 6 : 4}
                xs={indexCardCounter < 3 ? 12 : 6}
                className="mb-3"
              >
                {indexCardCounter < 3 ? (
                  <Container>
                    <ShopTaxonCard taxonId={childTax?.id} titleTag="h2" wide />
                  </Container>
                ) : (
                  <ShopTaxonCard taxonId={childTax?.id} titleTag="h2" />
                )}
              </Col>
            );
          })}
          {productList?.data
            ?.filter((obj) =>
              shopTaxon?.data?.relationships?.products?.data
                ?.map((tp) => tp.id)
                .includes(obj.id)
            )
            .map((product, index) => {
              const adjustedIndex =
                (taxonData?.relationships?.children?.data?.count || 0) + index;
              return (
                <Col
                  key={`product-${adjustedIndex}`}
                  xl={adjustedIndex < 2 ? 6 : 2}
                  lg={adjustedIndex < 2 ? 6 : 4}
                  xs={adjustedIndex < 2 ? 12 : 6}
                  className="mb-3"
                >
                  {adjustedIndex < 2 ? (
                    <Container>
                      <ShopProductCardBig
                        productId={product?.id}
                        titleTag="h2"
                      />
                    </Container>
                  ) : (
                    <ShopProductCard productId={product?.id} titleTag="h2" />
                  )}
                </Col>
              );
            })}

          {productList?.meta?.total_count === 0 &&
            taxonData?.attributes?.taxonomy_filter_ids && (
              <Col className="d-flex flex-column justify-content-center align-items-center">
                <p className="my-5 text-center">
                  {context.t("No Products found")}
                  <br />
                  {context.t("Please Change Filters or Category")}
                </p>
              </Col>
            )}
          {(productsLoading || taxonLoading) && (
            <>
              <Col lg={3} md={4} xs={6}>
                <div className="sk-loading sk-b30 bg-light" />
              </Col>
              <Col lg={3} md={4} xs={6}>
                <div className="sk-loading sk-b30 bg-light" />
              </Col>
              <Col lg={3} md={4} xs={6}>
                <div className="sk-loading sk-b30 bg-light" />
              </Col>
              <Col lg={3} md={4} xs={6}>
                <div className="sk-loading sk-b30 bg-light" />
              </Col>
            </>
          )}
        </Row>
        {productList?.data &&
          !productsLoading &&
          productList?.meta.total_count > productList?.meta.count && (
            <Button block onClick={loadMoreProducts} outline className="mt-5">
              {context.t("load more")}
            </Button>
          )}
      </Container>
      {taxonCmsBlocks?.map((cmsBlock, idx) => (
        <Container key={"cmsblock-" + idx} className="my-5">
          {cmsBlock?.template && <CMSBlock cmsBlock={cmsBlock} />}
        </Container>
      ))}
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
ShopCategory.contextTypes = {
  t: PropTypes.func,
};

/** export the redux connected component and add a frontload call */
export default ShopCategory;
